












import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class ListItemRow extends Vue {
  @Prop({ default: false }) disabled!: boolean;

  private get hasWave(): boolean {
    return this.$device.isSp();
  }
}
